import { dropdownMenu } from '@atoms/dropdown-menu';
import { updateNotifications } from '@organisms/header/notifications';
import { createApp } from 'vue';
import VueClickAway from 'vue3-click-away';
import DesktopVerticalMenu from './navUserDesktop/DesktopVerticalMenu.vue';

export const navUserDesktop = () => {
  updateNotifications();
  dropdownMenu('category');
  dropdownMenu('help');

  if (!document.getElementById('vertical-menu')) {
    return;
  }

  createApp(DesktopVerticalMenu)
    .use(VueClickAway)
    .mount('#vertical-menu');

  document.querySelector('#vertical-menu')?.setAttribute('data-ready', 'true');
};
